<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '手机号码',
            value: 'mobilePhone',
            type: 'input',
          },
          {
            label: '姓名',
            value: 'linkman',
            type: 'input',
          },
          {
            label: '收款名称',
            value: 'receiverName',
            type: 'input',
          },
          {
            label: '备注说明',
            value: 'remark',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
        ],
        rules: {
          mobilePhone: [ // 手机号码
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            // { validator: this.checkMobile, trigger: 'blur' },
          ],
          linkman: [ // 姓名
            { required: true, message: '请输入姓名', trigger: 'blur' },
          ],
          receiverName: [ // 收款名称
            { required: true, message: '请输入收款名称', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async sub () {
      const formData = await this.$refs.baseForm.sub();
      return formData;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return res;
    },
    init (data = {}) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: Boolean(this.$route.query.id),
        names: ['mobilePhone', 'linkman'],
      });
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
